// /wallet-ops/config → /wallet-ops/config/network. The bare Configuration
// URL (and old pre-split bookmarks) land on the Networks topic.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/wallet-ops/config/")({
  beforeLoad: () => {
    throw redirect({ to: "/wallet-ops/config/network", replace: true });
  },
});
